var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "powerbar-nav-top-level-item",
      class: { active: _vm.activeTopLevelIndex === _vm.itemIndex },
      attrs: { id: _vm.menuId, "aria-label": _vm.menuId, role: "navigation" }
    },
    [
      _vm.computedSubItems.length
        ? _c(
            "button",
            {
              attrs: { "aria-label": "Show " + _vm.caption + " sub-menu" },
              on: {
                click: _vm.toggleSecondLevelPanel,
                keyup: _vm.toggleSecondLevelPanel,
                mouseover: _vm.hoverMenu,
                mouseleave: _vm.hoverLeave,
                focusin: _vm.hoverMenu,
                focusout: _vm.hoverLeave
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.caption) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("second-level-menu-panel", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showActiveSecondLevelMenu,
            expression: "showActiveSecondLevelMenu"
          }
        ],
        attrs: { panelData: _vm.computedSubItems, itemIndex: _vm.itemIndex },
        on: { navigate: _vm.navigate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }